import type {
  ArchivePost,
  BoardConfig,
  EventPost,
  FaqPost,
  NoticePost,
  UpdatePost,
} from '../types/board.type.ts';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';
import { FAQ_CATEGORY_OPTIONS } from './faq.ts';
import {
  ARCHIVE_CATEGORY_OPTIONS,
  getArchiveSubCategoryOptions,
} from './archive.ts';

export const NOTICE_BOARD_CONFIG: BoardConfig<NoticePost> = {
  type: 'notices',
  title: '공지사항',
  description: '회사 및 서비스 운영 관련 소식을 알려드립니다.',
  basePath: PATHS.NEWS_NOTICES,
  detailPath: (id) => PATHS.noticeDetail(id),
  writePath: () => PATHS.noticeWrite(),
  editPath: (id) => PATHS.noticeEdit(id),
  categories: [
    { value: 'GENERAL', label: '일반' },
    { value: 'STANDARD', label: '기준개정' },
    { value: 'WAGE', label: '임금실태' },
    { value: 'EMERGENCY', label: '긴급' },
  ],
  rowFields: {
    showCategory: true,
    showViewCount: true,
  },
};

export const UPDATE_BOARD_CONFIG: BoardConfig<UpdatePost> = {
  type: 'updates',
  title: '업데이트',
  description: '제품 릴리즈 노트와 변경 사항을 정리합니다.',
  basePath: PATHS.NEWS_UPDATES,
  detailPath: (id) => PATHS.updateDetail(id),
  writePath: () => PATHS.updateWrite(),
  editPath: (id) => PATHS.updateEdit(id),
  categories: [
    { value: 'xcost-pro', label: 'XCOST PRO' },
    { value: 'xpixels-aqc', label: 'XPIXELS AQC' },
    { value: 'xpixels-sqc', label: 'XPIXELS SQC' },
    { value: 'xpixels-eqc', label: 'XPIXELS EQC' },
    { value: 'xpixels-mqc', label: 'XPIXELS MQC' },
    { value: 'homepage', label: '홈페이지' },
  ],
  rowFields: {
    showProduct: true,
    showVersion: true,
    showViewCount: true,
  },
};

export const EVENT_BOARD_CONFIG: BoardConfig<EventPost> = {
  type: 'events',
  title: '이벤트',
  description: '프로모션, 교육, 세미나 등 모든 행사 소식을 모았습니다.',
  basePath: PATHS.NEWS_EVENTS,
  detailPath: (id) => PATHS.eventDetail(id),
  writePath: () => PATHS.eventWrite(),
  editPath: (id) => PATHS.eventEdit(id),
  categories: [
    { value: 'ONGOING', label: '진행 중' },
    { value: 'UPCOMING', label: '예정' },
    { value: 'ENDED', label: '종료' },
  ],
  rowFields: {
    showThumbnail: true,
    showPeriod: true,
  },
};

export const ARCHIVE_BOARD_CONFIG: BoardConfig<ArchivePost> = {
  type: 'archives',
  title: '자료실',
  description: '적산자료, 표준품셈, 공사표준코드 등 업무 자료를 모았습니다.',
  basePath: PATHS.NEWS_ARCHIVES,
  detailPath: (id) => PATHS.archiveDetail(id),
  writePath: () => PATHS.archiveWrite(),
  editPath: (id) => PATHS.archiveEdit(id),
  categories: ARCHIVE_CATEGORY_OPTIONS,
  getSubCategoryOptions: getArchiveSubCategoryOptions,
  rowFields: {
    showCategory: true,
    showSubCategory: true,
    showViewCount: true,
    showAttachments: true,
  },
};

/**
 * FAQ 게시판 설정.
 * 공개 열람은 아코디언(FaqAccordionView)으로 렌더하지만, 작성/수정은 다른 게시판과
 * 동일하게 BoardWriteView/BoardEditView 를 재사용한다.
 * 상세 페이지가 없으므로 detailPath 는 아코디언 목록으로 돌려보낸다.
 */
export const FAQ_BOARD_CONFIG: BoardConfig<FaqPost> = {
  type: 'faqs',
  title: 'FAQ',
  description: '자주 묻는 질문을 모았습니다.',
  basePath: PATHS.SUPPORT_FAQS,
  detailPath: () => PATHS.SUPPORT_FAQS,
  writePath: () => PATHS.faqWrite(),
  editPath: (id) => PATHS.faqEdit(id),
  categories: FAQ_CATEGORY_OPTIONS,
  rowFields: {
    showCategory: true,
  },
};
